import React from 'react';
import { createColorStyles } from '../common/utilities';

export const Categories = ({ categories }) => {
    return (
        <div className="categories">
            <div className="spacer" />
            {
                categories.map((cat, index) => <div key={index} className={`category category-${cat.slug}`} style={createColorStyles(cat)}>{cat.name}</div>)
            }
        </div>
    );
};
